<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">직원관리</span>
            <span class="txt">현재 근무중인 직원을 확인할 수 있으며, 직원 설정이 가능합니다.</span>
        </div>
        <div class="com-search-content">
            <div class="line">
                <span class="txt">직원정보</span>

                <div v-if="!isCreate" class="float-right">
                    <button class="com-btn">직원삭제</button>

                    <!-- 재직직원 일시 -->
                    <button v-if="isInService" class="com-btn" @click="onClickResignation">퇴사처리</button>
                    <!-- //재직직원 일시 -->

                    <!-- 퇴사직원 일시 -->
                    <button v-else="!isInService" class="com-btn" @click="onClickReentry">재입사</button>
                    <!-- //퇴사직원 일시 -->
                </div>
            </div>
        </div>
        <div class="com-card-input">
            <div class="left-box">
                <div class="line">
                    <span class="tit">
                        이름
                        <span class="imp">*</span>
                    </span>
                    <div class="input-cnt">
                        <input v-model="editField.name" class="w220" type="text" />
                    </div>
                </div>
                <div class="line">
                    <span class="tit">닉네임</span>
                    <div class="input-cnt">
                        <input v-model="editField.nickName" class="w220" type="text" />
                    </div>
                </div>
                <div class="line">
                    <span class="tit">
                        연락처
                        <span class="imp">*</span>
                    </span>
                    <div class="input-cnt">
                        <div class="com-tel select-type">
                            <input
                                v-model="editField.phoneFirst"
                                maxlength="3"
                                type="text"
                                @keypress="isNumber($event)"
                                @keyup="onChangePhoneNumber"
                            />
                            <input
                                v-model="editField.phoneSecond"
                                maxlength="4"
                                type="text"
                                @keypress="isNumber($event)"
                                @keyup="onChangePhoneNumber"
                            />
                            <input
                                v-model="editField.phoneThird"
                                maxlength="4"
                                type="text"
                                @keypress="isNumber($event)"
                                @keyup="onChangePhoneNumber"
                            />
                            <button :disabled="!isNeedCheckPhone" class="com-btn" @click="checkDuplicatePhone">
                                중복확인
                            </button>
                        </div>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">
                        권한
                        <span class="imp">*</span>
                    </span>
                    <div class="input-cnt">
                        <select-form
                            :select-data="['선택', '영업팀', 'CS팀', '개발팀']"
                            class="w220"
                            @update:set="(val) => (setValue = val)"
                        ></select-form>
                    </div>
                </div>
            </div>
            <div class="right-box">
                <div class="line">
                    <span class="tit">
                        이메일
                        <span class="imp">*</span>
                    </span>
                    <div class="input-cnt">
                        <div class="com-email">
                            <input v-model="editField.emailFirst" class="first" type="text" />
                            <span class="txt">@</span>
                            <input v-model.trim="editField.emailSecond" class="last" type="text" />
                            <select-form
                                :select-data="['직접 입력', ...emailTypeList]"
                                :select-value="['', ...emailTypeValueList]"
                                @update:set="(val) => (editField.emailSecond = val)"
                            ></select-form>
                        </div>
                    </div>
                </div>
                <!--
                고객 요구에 의해서 해당 입력 폼을 삭제함
                <div class="line">
                    <span class="tit">비밀번호 <span class="imp">*</span></span>
                    <div class="input-cnt">
                        <input type="password" class="w220" v-model="editField.password">
                    </div>
                </div>
                <div class="line">
                    <span class="tit">비밀번호 확인 <span class="imp">*</span></span>
                    <div class="input-cnt">
                        <input type="password" class="w220" v-model="editField.retypePassword">
                    </div>
                </div>
                -->
            </div>
        </div>
        <div class="bottom-btn">
            <button class="com-btn" @click="onClickBtnCancel">취소</button>
            <button v-if="isCreate" class="com-btn blue" @click="createStaff">등록</button>
            <button v-else class="com-btn blue" @click="updateStaff">수정</button>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import { validateEmail } from '@/assets/js/validation.js';

export default {
    name: 'employeeEdit',
    props: {},
    computed: {
        // 등록, 수정 페이지인지 구분 (true를 반환하면 등록, false를 반환하면 수정)
        isCreate() {
            return this.staffId == null;
        },
        // 재직중인 직원여부 구분 (true를 반환하면 재직중, false를 반환하면 퇴사함)
        isInService() {
            return !this.isCreate && this.staffInfo.status === 'I';
        },
        fullPhoneNumber() {
            const ed = this.editField;
            return `${ed.phoneFirst}${ed.phoneSecond}${ed.phoneThird}`;
        },
        fullEmail() {
            const ed = this.editField;
            return `${ed.emailFirst}@${ed.emailSecond}`;
        },
    },
    data() {
        return {
            isLoading: false,
            isNeedCheckPhone: false,
            availablePhoneNumber: '',
            staffId: this.$route.params.id,
            staffInfo: {},
            editField: {
                name: '',
                nickName: '',
                // password: '',
                // retypePassword: '',
                phoneFirst: '',
                phoneSecond: '',
                phoneThird: '',
                emailFirst: '',
                emailSecond: '',
            },
            emailTypeList: ['naver.com', 'gmail.com', 'daum.net', 'nate.com'],
            emailTypeValueList: ['naver.com', 'gmail.com', 'daum.net', 'nate.com'],
        };
    },
    mounted() {
        if (this.staffId != null) {
            this.staffId = parseInt(this.staffId);
            this.fetchStaffDetail();
        } else {
            this.imageUrl = '/img/temp/brand_logo.png';
            this.logoUrl = '/img/temp/brand_logo.png';
        }
    },
    methods: {
        isNumber(evt) {
            evt = evt || window.event;
            const charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },

        onChangePhoneNumber() {
            const { fullPhoneNumber } = this;

            switch (fullPhoneNumber) {
                case '':
                case this.staffInfo.phone:
                case this.availablePhoneNumber:
                    this.isNeedCheckPhone = false;
                    break;
                default:
                    this.isNeedCheckPhone = true;
                    break;
            }
        },
        onClickBtnCancel() {
            this.$router.push('/madmin/employee/list');
        },
        onClickResignation() {
            if (!confirm('직원을 퇴사처리하시겠습니까?')) {
                return false;
            }

            this.updateStaffStatus('O');
        },

        onClickReentry() {
            if (!confirm('직원을 퇴사처리하시겠습니까?')) {
                return false;
            }

            this.updateStaffStatus('I');
        },

        async updateStaffStatus(status) {
            const { staffId } = this;
            const params = { id: staffId, status };

            try {
                const { data } = await this.sendPutStaff(params);

                console.log('===> Success update : ', data);
                alert('처리되었습니다.');

                this.$router.push({ name: 'employeeList' });
            } catch (error) {
                alert('오류가 발생했습니다.');
                console.log('===> Failed update : ', error);
                console.log(centerData);
            }
        },

        async checkDuplicatePhone() {
            // 중복확인할 필요가 없는 경우
            if (!this.isNeedCheckPhone) {
                return;
            }

            const { phoneFirst, phoneSecond, phoneThird } = this.editField;

            // 전화번호
            if (phoneFirst.trim() === '' || phoneSecond.trim() === '' || phoneThird.trim() === '') {
                alert('연락처를 입력하세요');
                return false;
            }

            // 수정이고, 기존 전화번호와 동일한 번호를 입력한 경우
            if (!this.isCreate && this.staffInfo.phone == this.fullPhoneNumber) {
                this.isNeedCheckPhone = false;
                return false;
            }

            const { data } = await api.get(`/admin/api/ft/staff/phone/${this.fullPhoneNumber}/duplicate`);

            if (!data) {
                this.isNeedCheckPhone = false;
                this.availablePhoneNumber = this.fullPhoneNumber;
                alert('사용가능한 번호입니다.');
            } else {
                this.isNeedCheckPhone = true;
                this.availablePhoneNumber = '';
                alert('사용중인 번호입니다.');
            }
        },

        // 직원 정보 API
        getStaffDetail(staffId) {
            return api.get(`/admin/api/ft/staff/${staffId}`);
        },

        // 직원 정보 fetch
        async fetchStaffDetail() {
            try {
                this.isLoading = true;
                const { data } = await this.getStaffDetail(this.staffId);

                this.staffInfo = { ...data };

                this.editField.name = data.name;
                this.editField.nickName = data.nickName;
                this.splitEmail(data.email);
                this.splitPhoneNumber(data.phone);

                this.isLoading = false;

                console.log('===> Loading staff detail Successfully : ', data);
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },

        // 이메일 주소 Split
        splitEmail(email) {
            if (email !== '') {
                this.editField.emailFirst = email.split('@')[0];
                this.editField.emailSecond = email.split('@')[1];
            }
        },

        // 전화번호 Split
        splitPhoneNumber(no) {
            const length = no.length;
            if (length == 11 && no.substr(0, 2) != '02') {
                // 010-1234-1234
                this.editField.phoneFirst = no.substr(0, 3);
                this.editField.phoneSecond = no.substr(3, 4);
                this.editField.phoneThird = no.substr(7, 4);
            } else if (length == 10 && no.substr(0, 2) != '02') {
                // 031-123-4567
                this.editField.phoneFirst = no.substr(0, 3);
                this.editField.phoneSecond = no.substr(3, 3);
                this.editField.phoneThird = no.substr(6, 4);
            } else if (length == 10 && no.substr(0, 2) == '02') {
                // 02-1234-4567
                this.editField.phoneFirst = no.substr(0, 2);
                this.editField.phoneSecond = no.substr(2, 4);
                this.editField.phoneThird = no.substr(6, 4);
            } else if (length == 9 && no.substr(0, 2) == '02') {
                // 02-123-4567
                this.editField.phoneFirst = no.substr(0, 2);
                this.editField.phoneSecond = no.substr(2, 3);
                this.editField.phoneThird = no.substr(5, 4);
            }
        },

        validateValues() {
            // 필수값 체크
            let result = false;
            const { name, phoneFirst, phoneSecond, phoneThird, emailFirst, emailSecond } = this.editField;
            let msg = '';

            // 이름
            if (name.trim() === '') {
                msg = '이름을 입력하세요';
                return { result, msg };
            }

            // 전화번호
            if (phoneFirst.trim() === '' || phoneSecond.trim() === '' || phoneThird.trim() === '') {
                msg = '연락처를 입력하세요';
                return { result, msg };
            }

            if (this.isNeedCheckPhone) {
                msg = '연락처 중복확인을 해주세요';
                return { result, msg };
            }

            // 이메일
            if (emailFirst.trim() === '' || emailSecond.trim() === '') {
                msg = '이메일을 입력하세요';
                return { result, msg };
            } else if (!validateEmail(this.fullEmail)) {
                msg = '이메일을 확인하세요';
                return { result, msg };
            }

            // 비밀번호
            /*
const { password, retypePassword } = this.editField;

if( this.isCreate && password.trim() === '') {
msg = '비밀번호를 입력하세요';
return { result, msg };
}

if( password.trim() !== '' && password !== retypePassword ) {
msg = '비밀번호를 확인하세요';
return { result, msg };
}
*/

            result = true;
            return { result };
        },

        async createStaff() {
            const validate = this.validateValues();

            if (!validate.result) {
                alert(validate.msg);
                return false;
            }

            if (!confirm('직원등록을 하시겠습니까?')) {
                return false;
            }

            const params = this.getCreateParams();

            try {
                const { data } = await this.sendPostStaff(params);

                console.log('===> Success Staff create : ', data);
                alert('직원이 등록 되었습니다.');

                this.$router.push({ name: 'employeeList' });
            } catch (error) {
                alert('오류가 발생했습니다.');
                console.log('===> Failed Center create : ', error);
            }
        },

        async updateStaff() {
            const validate = this.validateValues();

            if (!validate.result) {
                alert(validate.msg);
                return false;
            }

            if (!confirm('직원수정을 하시겠습니까?')) {
                return false;
            }

            const params = this.getUpdateParams();

            console.log(params);

            const keys = Object.keys(params);
            if (keys.length <= 1) {
                alert('변경할 정보가 없습니다.');
                return false;
            }

            try {
                const { data } = await this.sendPutStaff(params);

                console.log('===> Success update : ', data);
                alert('직원이 수정 되었습니다.');

                // this.$router.push( {name:"employeeList"} );
            } catch (error) {
                alert('오류가 발생했습니다.');
                console.log('===> Failed update : ', error);
                console.log(centerData);
            }
        },

        sendPostStaff(staffData) {
            return api.post('/admin/api/ft/staff', {
                ...staffData,
            });
        },

        sendPutStaff(staffData) {
            return api.put('/admin/api/ft/staff', {
                ...staffData,
            });
        },

        getCreateParams() {
            const { name, nickName /* , password */ } = this.editField;
            const phone = this.fullPhoneNumber;
            const email = this.fullEmail;
            const roleId = 0; // 권한 임시 처리
            const status = this.isCreate ? 'I' : this.staffInfo.status;

            // 현재 UI에 입력값 없음
            const birthday = '';
            const sex = '';

            return {
                roleId,
                name,
                nickName,
                phone,
                email,
                // password,
                status,
                birthday,
                sex,
            };
        },

        getUpdateParams() {
            const { staffId, fullPhoneNumber, fullEmail, staffInfo, editField } = this;

            console.log('staffId', staffId);

            const params = { id: staffId };

            if (staffInfo.name !== editField.name) {
                params.name = editField.name;
            }
            if (staffInfo.nickName !== editField.nickName) {
                params.nickName = editField.nickName;
            }
            if (staffInfo.phone !== fullPhoneNumber) {
                params.phone = fullPhoneNumber;
            }
            if (staffInfo.email !== fullEmail) {
                params.email = fullEmail;
            }
            /*
if( editField.password !== '' ) {
params.password = editField.password;
}
*/

            return params;
        },
    },
};
</script>
<style lang="scss"></style>
